export enum GET_PAGINATED_ORGANIZATION_TCES_SENT_TO_INTEGRATIVE_COLUMNS {
  NAME = 'NAME',
  CPF = 'CPF',
  GROUP_NAME = 'GROUP_NAME',
  GROUP_CODE = 'GROUP_CODE',
  INTERNSHIP_LOCATION_NAME = 'INTERNSHIP_LOCATION_NAME',
  PERIOD = 'PERIOD',
  UPDATED_AT = 'UPDATED_AT',
}

export interface GetPaginatedOrganizationTcesSentToIntegrativeParams {
  organizationHashId: string;
  page: number;
  length: number;
  courseHashIds?: string[];
  groupHashIds?: string[];
  search?: string;
  orderColumn?: GET_PAGINATED_ORGANIZATION_TCES_SENT_TO_INTEGRATIVE_COLUMNS;
  orderDirection?: 'ASC' | 'DESC';
}
